import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {Row, Col, Container} from '@modifi/ui'

import {DefaultComponentWrapper} from '../common'
import {StyledA, LogoWrapper} from './styles'
import Picture from '../../ui/cms-picture'

const propTypes = {
  logoLists: PropTypes.arrayOf(
    PropTypes.shape({
      logo: PropTypes.string.isRequired,
      targetUrl: PropTypes.string,
      alternateTextForLogo: PropTypes.string,
    })
  ),
  lightUpOnFocus: PropTypes.bool,
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  logoLists: [],
  lightUpOnFocus: false,
  backgroundColor: undefined,
}

export type ExternalLogoListsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const ExternalLogoLists: React.FC<ExternalLogoListsProps> = ({
  logoLists,
  lightUpOnFocus,
  backgroundColor,
}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <Container>
      <Row justifyContent="center" alignItems="center">
        {logoLists?.map((logoParams, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <Col col={12} md="auto" key={`logolist-${index}`}>
            <LogoWrapper>
              {logoParams?.targetUrl ? (
                <StyledA
                  to={logoParams?.targetUrl}
                  targetBlank
                  lightUpOnFocus={lightUpOnFocus}
                  isExternal={logoParams?.targetUrl.includes('http')}
                >
                  <Picture
                    alt={logoParams?.alternateTextForLogo || ''}
                    src={logoParams?.logo}
                    id={logoParams?.alternateTextForLogo || ''}
                    disableResize
                  />
                </StyledA>
              ) : (
                <StyledA as="div" lightUpOnFocus={lightUpOnFocus}>
                  <Picture
                    alt={logoParams?.alternateTextForLogo || ''}
                    src={logoParams?.logo}
                    id={logoParams?.alternateTextForLogo || ''}
                    disableResize
                  />
                </StyledA>
              )}
            </LogoWrapper>
          </Col>
        ))}
      </Row>
    </Container>
  </DefaultComponentWrapper>
)

ExternalLogoLists.propTypes = propTypes

ExternalLogoLists.defaultProps = defaultProps

export default ExternalLogoLists
